import React, { useState } from "react";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Paper as MuiPaper,
  CardContent,
  Box,
  Chip,
  red,
  yellow,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useDialog } from "../../../contexts/DialogContext";

import ComplaintMore from "../../../components/ComplaintMore";
import Toolbar from "../../../components/Toolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import AdvanceFilter from "./AdvanceFilter";
import useComplaint from "../../../hooks/useComplaint";
import useMainContentDimensions from "../../../utils/mainContentDimensions";
import EditDelete from "../../../components/EditDelete";
import ApproveOrReject from "./ApproveOrReject";

import { Link } from "react-router-dom";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

const breadCrump = () => {
  return (
    <Breadcrumbs aria-label="Breadcrumb" mt={2}>
      <Typography>Caf Form</Typography>
      <Typography>List</Typography>
    </Breadcrumbs>
  );
};

const CustomDataGrid = (props) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const { isLoadingDownload, downloadFileType } = useComplaint();

  const { height, width } = useWindowDimensions();
  const { width: mainContentWidth } = useMainContentDimensions();

  const {
    editPage,
    addPage,
    trans,
    rows,
    rowCount,
    payload,
    setPayload,
    setFilterResetFunc,
    isLoading,
    id,
    handleSortModelChange,
    sortModel,
    downloadFile,
    openDownloadDialog,
    viewDetails,
    fetchData,
    refreshPage,
    paginationModel,
    paginationMeta,
    paging,
    onPaginationModelChange,
  } = props;
  console.log(rowCount, "loading child component");

  const { openDialog } = useDialog();

  const userStatus = (status) => {
    const chipStyles = {
      width: "100px", // Set the desired width for all chips
      textAlign: "center", // Center align the text in each chip
    };

    if (status === "PENDING") {
      return <Chip label="PENDING" color="primary" sx={chipStyles} />;
    } else if (status === "APPROVED") {
      return <Chip label="APPROVED" color="success" sx={chipStyles} />;
    } else if (status === "REJECTED") {
      return <Chip label="REJECTED" color="error" sx={chipStyles} />;
    }
  };

  const columns = [
    {
      field: "action",
      headerName: "Action",
      filter: false,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e) => {
          e.stopPropagation(); // don't select this row after clicking
          const api = params.api;
          const thisRow = {};
          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach((c) => (thisRow[c.field] = params.getValue(params.id, c.field)));
          console.log(thisRow, "thisRow");
        };
        return (
          <EditDelete rowClick={onClick} editPage={() => editPage(params.id)} menus={["edit"]} />
        );
      },
    },
    {
      field: "cafNumber",
      headerName: "CAF Number",
      width: 120,
    },
    {
      field: "userName",
      headerName: "Profile Id",
      width: 120,
    },
    {
      field: "fullName",
      headerName: "Full Name",
      renderCell: (params) => <Link to={"/caf/details?id=" + params.id}>{params.value}</Link>,
      width: 200,
    },
    {
      field: "mobileNo",
      headerName: "Mobile No",
      width: 120,
    },
    {
      field: "emailId",
      headerName: "Email Id",
      width: 200,
    },
    {
      field: "planName",
      headerName: "Plan Name",
      width: 200,
    },
    {
      field: "status",
      headerName: "Status",
      renderCell: (params) => {
        return userStatus(params.row["status"]);
      },
      width: 200,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  const approveOrRejectCAF = () => {
    return openDialog(
      "approve_or_reject",
      "Approve or Reject CAF",
      <ApproveOrReject selectedRows={selectedRows} refreshPage={refreshPage} />,
    );
  };

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            addPage={addPage}
            downloadFile={downloadFile}
            openDownloadDialog={openDownloadDialog}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
            approveOrRejectCAF={approveOrRejectCAF}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {trans("caf_list")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DataGrid
            checkboxSelection
            initialState={{
              pagination: { paginationModel: { pageSize: 100 } },
            }}
            rowCount={rowCount}
            getRowId={(row) => row[id]}
            columns={columns}
            rows={rows}
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMeta={paginationMeta}
            loading={isLoading}
            pageSizeOptions={[25, 50, 100]}
            paginationMode="server"
            onPaginationModelChange={onPaginationModelChange}
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            paginationModel={paginationModel}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            isRowSelectable={(params) =>
              params.row.status == "PENDING" || params.row.status == "REJECTED"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": {
                backgroundColor: "#f9f9f9", // Light gray for even rows
              },
              "& .MuiDataGrid-row.odd-row": {
                backgroundColor: "#ffffff", // White for odd rows
              },
            }}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setSelectedRows(newRowSelectionModel);
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
CustomDataGrid.propTypes = {
  editPage: PropTypes.func.isRequired,
  addPage: PropTypes.func.isRequired,
  trans: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  rowCount: PropTypes.number.isRequired,
  paging: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  handleSortModelChange: PropTypes.func.isRequired,
  sortModel: PropTypes.object.isRequired,
};
export default CustomDataGrid;
